<template>
  <div>
    <partner-tab></partner-tab>
    <router-view />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import PartnerDetailsFTab from "../components/tab/PartnerDetailsFTab.vue";

@Component({
  components: {
    "partner-tab": PartnerDetailsFTab,
  },
})
export default class TaskListLayout extends Vue {}
</script>
